import { ToastMixin } from '@/mixins/globalUtils';

export interface IUploadBox {
  file?: File;
  createToast?: ToastMixin;
  UploadBoxMode: typeof UploadBoxMode;
}

export enum UploadBoxMode {
  FILE = 'file',
  MULTIPLE_FILES = 'multipleFiles',
  DIRECTORY = 'directory',
}

export enum FileExtension {
  CSV = '.csv',
  ZIP = '.zip',
}
